<!-- <section id="hero" class="hero-video" [ngClass]="homeHero_params.aspectClass">
    <div class="vimeo-wrapper">
        <iframe [src]="homeHero_params.urlVideoSafe" frameborder="0" allowfullscreen title="Hero Video"></iframe>
    </div>
</section> -->

<section id="hero-no-contentw100" class="hero-no-contentw100">


    <div class="vimeo-wrapper-nocontent">


        <div class="d-none d-sm-block v-desktop">
            <iframe [src]="homeHero_params.urlVideoSafe" width="1920" height="1080"
                title="retailCo. Damos vida a los locales" frameborder="0" webkitallowfullscreen mozallowfullscreen
                allowfullscreen>
            </iframe>
        </div>

        <div class="d-block d-sm-none v-mobile">
            <iframe [src]="homeHero_params.urlVideoSafe" width="1280" height="720"
                title="retailCo. Damos vida a los locales (versión móvil)" frameborder="0" webkitallowfullscreen
                mozallowfullscreen allowfullscreen>
            </iframe>
        </div>

    </div>


</section>